"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.addMesList = addMesList;
exports.allContract = allContract;
exports.createChange = createChange;
exports.createMesListAndSaveAudit = createMesListAndSaveAudit;
exports.createMesOrder = createMesOrder;
exports.default = void 0;
exports.del = del;
exports.delMesList = delMesList;
exports.edit = edit;
exports.editCustMesList = editCustMesList;
exports.getMesList = getMesList;
exports.getServiceCodeList = getServiceCodeList;
exports.placeOrder = placeOrder;
exports.quotation = quotation;
exports.syncIMESContractLog = syncIMESContractLog;

var _request = _interopRequireDefault(require("@/utils/request"));

function add(data) {
  return (0, _request.default)({
    url: 'api/custMesOrder',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/custMesOrder/',
    method: 'delete',
    data: ids
  });
}

function delMesList(ids) {
  return (0, _request.default)({
    url: 'api/custMesList/',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/custMesOrder',
    method: 'put',
    data: data
  });
}

function editCustMesList(data) {
  return (0, _request.default)({
    url: 'api/custMesList',
    method: 'put',
    data: data
  });
}

function getMesList(serviceCode) {
  return (0, _request.default)({
    url: 'api/custMesList/all?serviceCode=' + serviceCode,
    method: 'get'
  });
}

function getServiceCodeList(custId) {
  return (0, _request.default)({
    url: 'api/custMesOrder/all?custId=' + custId,
    method: 'get'
  });
}

function addMesList(data) {
  return (0, _request.default)({
    url: 'api/custMesList',
    method: 'post',
    data: data
  });
}

function createMesListAndSaveAudit(data) {
  return (0, _request.default)({
    url: 'api/custMesList/createMesListAndSaveAudit',
    method: 'post',
    data: data
  });
}

function createChange(data) {
  return (0, _request.default)({
    url: 'api/custMesList/createChange',
    method: 'post',
    data: data
  });
}

function allContract(custId) {
  return (0, _request.default)({
    url: 'api/contract/all?custId=' + custId,
    method: 'get'
  });
}

function createMesOrder(data) {
  return (0, _request.default)({
    url: 'api/custMesOrder/createMesOrder',
    method: 'post',
    data: data
  });
}

function placeOrder(data) {
  return (0, _request.default)({
    url: 'api/custMesOrder/placeOrder',
    method: 'post',
    data: data
  });
}

function quotation(data) {
  return (0, _request.default)({
    url: 'api/custMesOrder/quotation',
    method: 'post',
    data: data
  });
}

function syncIMESContractLog(contractNo) {
  var axios = require('axios');

  return axios.get('https://api98082.iaggf.net:8082/api/IMESFile/SyncIMESContractLog', {
    params: {
      contractNo: contractNo
    }
  });
}

var _default = {
  syncIMESContractLog: syncIMESContractLog,
  createChange: createChange,
  quotation: quotation,
  editCustMesList: editCustMesList,
  add: add,
  edit: edit,
  del: del,
  getMesList: getMesList,
  getServiceCodeList: getServiceCodeList,
  addMesList: addMesList,
  allContract: allContract,
  createMesOrder: createMesOrder,
  createMesListAndSaveAudit: createMesListAndSaveAudit,
  placeOrder: placeOrder,
  delMesList: delMesList
};
exports.default = _default;